import { APIURL } from "./Constants";

export default class NetworkService {
  async getActiveProjectsService(token) {
    let requesturl = process.env.REACT_APP_API_URL + "ActiveProject/GetActiveProjects";
    let bearer = `Bearer ${token}`;
    const settings = {
      method: "GET",
      headers: {
        Authorization: bearer,
      },
    };

    console.log("XX", bearer);
    try {
      const response = await fetch(requesturl, settings);
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return error;
    }
  }

  async getGroups(accessToken) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: bearer,
      },
      body: JSON.stringify({
        securityEnabledOnly: false,
      }),
    };

    return fetch("https://graph.microsoft.com/v1.0/me/getMemberGroups", options)
      .then((response) => response.json())
      .catch((error) => console.log(error));
  }

  async getActiveCCService(token) {
    let requesturl =
      process.env.REACT_APP_API_URL + "ActiveProjectCategory/GetAllActiveProjectsCategory";
    let bearer = `Bearer ${token}`;
    const settings = {
      method: "GET",
      headers: {
        Authorization: bearer,
      },
    };

    try {
      const response = await fetch(requesturl, settings);
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return error;
    }
  }

  async updateCCTypeService(allCCTypes, accessToken) {
    let strInput = JSON.stringify(allCCTypes);
    const bearer = `Bearer ${accessToken}`;
    let requesturl =
      process.env.REACT_APP_API_URL + "ActiveProjectCategory/UpdateActiveProjectsCategory";
    try {
      const response = await fetch(requesturl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: bearer,
        },
        body: strInput,
      });
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return error;
    }
  }

  async addRetirementService(input, accessToken) {
    let strInput = JSON.stringify(input);
    const bearer = `Bearer ${accessToken}`;
    let requesturl = process.env.REACT_APP_API_URL + "Retirement/AddRetirementAdHoc";
    try {
      const response = await fetch(requesturl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: bearer,
        },
        body: strInput,
      });
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return error;
    }
  }

  async sendCertificateEmail(accessToken) {
    const bearer = `Bearer ${accessToken}`;
    let requesturl =
      process.env.REACT_APP_API_URL + "EmailNotification/SendEmail?EmailType=Certificate";
    try {
      const response = await fetch(requesturl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: bearer,
        },
      });
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return error;
    }
  }

  async queueCertificateEmail(input, accessToken) {
    const bearer = `Bearer ${accessToken}`;
    let requesturl =
      process.env.REACT_APP_API_URL +
      `Certificate/QueueCertificateEmail?CertificateNumber=${input}`;
    try {
      const response = await fetch(requesturl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: bearer,
        },
      });
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return error;
    }
  }

  async getCertificateEmailTemplateService(accessToken) {
    let requesturl = process.env.REACT_APP_API_URL + "CertificateEmailTemplate";
    const bearer = `Bearer ${accessToken}`;
    const settings = {
      method: "GET",
      headers: {
        Authorization: bearer,
      },
    };
    try {
      const response = await fetch(requesturl, settings);
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return error;
    }
  }

  async editCertificateEmailTemplateService(input, id, accessToken) {
    let strInput = JSON.stringify(input);

    let requesturl = process.env.REACT_APP_API_URL + `CertificateEmailTemplate/${id}`;
    let bearer = `Bearer ${accessToken}`;

    try {
      const response = await fetch(requesturl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: bearer,
        },
        body: strInput,
      });
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return error;
    }
  }

  async getEnergyPlanService(token) {
    let requesturl = process.env.REACT_APP_API_URL + "EnergyPlan";
    let bearer = `Bearer ${token}`;
    const settings = {
      method: "GET",
      headers: {
        Authorization: bearer,
      },
    };
    try {
      const response = await fetch(requesturl, settings);
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return error;
    }
  }

  async getResidentialCertificateTemplateService(token) {
    let requesturl = process.env.REACT_APP_API_URL + "CertificateTemplateResidential";
    let bearer = `Bearer ${token}`;
    const settings = {
      method: "GET",
      headers: {
        Authorization: bearer,
      },
    };
    try {
      const response = await fetch(requesturl, settings);
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return error;
    }
  }

  async getBusinessCertificateTemplateService(token) {
    let requesturl = process.env.REACT_APP_API_URL + "CertificateTemplateCnI";
    let bearer = `Bearer ${token}`;
    const settings = {
      method: "GET",
      headers: {
        Authorization: bearer,
      },
    };
    try {
      const response = await fetch(requesturl, settings);
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return error;
    }
  }

  async editResidentialCertificateTemplateService(input, id, token) {
    let strInput = JSON.stringify(input);

    let requesturl = process.env.REACT_APP_API_URL + `CertificateTemplateResidential/${id}`;
    let bearer = `Bearer ${token}`;

    try {
      const response = await fetch(requesturl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: bearer,
        },
        body: strInput,
      });
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return error;
    }
  }

  async editCnICertificateTemplateService(input, id, token) {
    let strInput = JSON.stringify(input);

    let requesturl = process.env.REACT_APP_API_URL + `CertificateTemplateCnI/${id}`;
    let bearer = `Bearer ${token}`;
    try {
      const response = await fetch(requesturl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: bearer,
        },
        body: strInput,
      });
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return error;
    }
  }

  async getAllCertificatesService(accessToken) {
    let requesturl = process.env.REACT_APP_API_URL + "Certificate/ViewAllCertificate";
    const bearer = `Bearer ${accessToken}`;
    const settings = {
      method: "GET",
      headers: {
        Authorization: bearer,
      },
    };
    try {
      const response = await fetch(requesturl, settings);
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return error;
    }
  }

  async getAllAdHocCertificatesService(accessToken) {
    let requesturl = process.env.REACT_APP_API_URL + "Certificate/ViewAllAdhocCertificate";
    const bearer = `Bearer ${accessToken}`;
    const settings = {
      method: "GET",
      headers: {
        Authorization: bearer,
      },
    };
    try {
      const response = await fetch(requesturl, settings);
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return error;
    }
  }

  async getAllCertificatesByService(input, accessToken) {
    // dataInput=JSON.stringify(input);
    let requesturl =
      process.env.REACT_APP_API_URL +
      `Certificate/ViewAllCertificateBy?CustomerType=${input.customerType}&RetirementType=${input.retirementType}&status=${input.status}`;
    const bearer = `Bearer ${accessToken}`;
    const settings = {
      method: "GET",
      headers: {
        Authorization: bearer,
      },
    };
    try {
      const response = await fetch(requesturl, settings);
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return error;
    }
  }

  async regenerateFailedCertService(input, accessToken) {
    let strInput = JSON.stringify(input);
    let requesturl =
      process.env.REACT_APP_API_URL + `Certificate/RegenerateFailedCert?Id=${input.id}`;
    const bearer = `Bearer ${accessToken}`;

    try {
      const response = await fetch(requesturl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: bearer,
        },
      });
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return error;
    }
  }

  async getDashboard(token) {
    let requesturl = process.env.REACT_APP_API_URL + "Dashboard/GetAll";
    let bearer = `Bearer ${token}`;
    const settings = {
      method: "GET",
      headers: {
        Authorization: bearer,
      },
    };
    try {
      const response = await fetch(requesturl, settings);
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      return error;
    }
  }
}
